export const ActivationState = {
    SolverEnabled: "SolverEnabled",
    SolverDisabled: "SolverDisabled",
    UserEnabled: "UserEnabled",
    UserDisabled: "UserDisabled",
    isActive(state) {
        return state === "SolverEnabled" || state === "UserEnabled";
    },
    isUserDecision(state) {
        return state === "UserEnabled" || state === "UserDisabled";
    },
    storageData(state) {
        switch (state) {
            case "UserEnabled":
                return true;
            case "UserDisabled":
                return false;
            case "SolverEnabled":
            case "SolverDisabled":
                return null;
        }
    },
    fromStorageData(value) {
        if (value === true)
            return "UserEnabled";
        if (value === false)
            return "UserDisabled";
        return "SolverDisabled";
    },
};
